export enum TipoBeneficio {
    Promocao = 1,
    Experiencia = 2,
    Beneficio = 3,
    ComResgateDeProdutos = 4,
    ProdutosCs = 15
}